'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Group=require('../../../dist-es6/shared/domain/group');let

FlattenedGroupsExtensions=class FlattenedGroupsExtensions{
constructor(flattenedGroupsTree){
this._flattenedGroupsTree=flattenedGroupsTree;
this._groupsById=_.keyBy(flattenedGroupsTree,'id');
}

getDisplayNamesById(){
const displayNameByGroupMap=new Map;

for(const group of this._flattenedGroupsTree){
displayNameByGroupMap.set(group.id,this.getDisplayNameFor(group));
}

return displayNameByGroupMap;
}

getDisplayNameFor(group){
if(group.id===null||group.id===Group.FakeWholeOrgGroupId){
return'Organization';
}

const parents=[];

let lastChild=group;
while(lastChild=this._groupsById[lastChild.parentId]){
if(lastChild.id===null){
break;
}
parents.push(lastChild);
}

const orderedParentGroups=parents.map(p=>p.name).reverse();


return _.concat(orderedParentGroups,group.name).join(' > ');
}

static extend(flattenedGroupsTree){
return new FlattenedGroupsExtensions(flattenedGroupsTree);
}};


module.exports=FlattenedGroupsExtensions.extend;
//# sourceMappingURL=flattenedGroupsExtensions.js.map
